
import {$, ID, Resource, TAG} from 'simpli-web-sdk'

export default class Insumo extends Resource {
    readonly $name: string = 'Insumo'

    readonly $endpoint: string = '/user/me/tipo-de-insumo'

    get $id() {
        return this.idInsumoPk
    }
    set $id(val: ID) {
        this.idInsumoPk = val
    }

    get $tag() {
        return this.descricao
    }
    set $tag(val: TAG) {
        this.descricao = val
    }

    idInsumoPk: ID = 0

    descricao: string = ''
}
